import type { TrackingEvent, TrackingEventPayload } from '~/types/tracking'

// hook
export const useEventTracking = () => {
  const { gtag } = useGtag()

  const isProduction = process.env.NUXT_PUBLIC_SITE_URL === 'https://www.caseclub.in.th'

  const on = <T extends TrackingEvent>(event: T, payload: TrackingEventPayload[T]) => {
    if (!event || !payload) {
      if (!isProduction) {
        console.warn('Missing tracking event or payload')
      }
      return
    }

    if (!isProduction) {
      console.log('[Gtag Tracking]', event, payload)
    }

    gtag('event', event, payload)
  }

  return {
    on
  }
}
